import { Pipe, PipeTransform } from '@angular/core';
import { LoggingService } from '../../shared/services/logging/logging.service';

const log = new LoggingService();
@Pipe({
    name: 'itemlookup',
    standalone: false
})
export class ItemLookupPipe implements PipeTransform {
    transform(ary: any, field: string, id: any): any {
        try {
            const result =
                Array.isArray(ary) && ary.length
                    ? ary.find(x => x[field].toString() === id.toString())
                    : { [`${field}`]: id };
                    // log.verbose({type: 'ItemLookupPipe', ary, field, id, result});
                    return result || id;
        } catch (e) {
            return id;
        }
    }
}
